import { DEFAULTS } from "./constants";
import type { useDates } from "./DatesContext";

export const generateUrl = (
  to: string | undefined,
  { group, period, compare, start, end, preStart, preEnd }: ReturnType<typeof useDates>,
) => {
  const [url, paramString] = to?.split("?") ?? ["", ""];
  const params = new URLSearchParams(paramString || "");

  if (group && !params.has("group") && group !== DEFAULTS.group.id) params.append("group", group);
  if (period && !params.has("period") && period !== DEFAULTS.group.defaultPeriod) params.append("period", period);
  if (compare && !params.has("compare") && compare !== DEFAULTS.compare.id) params.append("compare", compare);

  if (period === "custom") {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (start && !params.has("start")) params.append("start", start.format("YYYY-MM-DD"));
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (end && !params.has("end")) params.append("end", end.format("YYYY-MM-DD"));
  }

  if (compare === "custom") {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (preStart && !params.has("preStart")) params.append("preStart", preStart.format("YYYY-MM-DD"));
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (preEnd && !params.has("preEnd")) params.append("preEnd", preEnd.format("YYYY-MM-DD"));
  }

  return `${url}?${params.toString()}`;
};
